import type { Dispatch } from 'redux';
import type { TFunction } from 'i18next';
import { GridActionsCellItem, type GridColDef } from '@mui/x-data-grid-premium';

import { Icon, showDeleteDialog } from 'app/main/components';
import { ViewTableUtils } from 'app/main/components/page-layouts';

import { showSkillsEvaluationsEditDialog } from './SkillsEvaluationsEditDialog';

type useSkillsEvaluationsTableColumnsType = (params: {
	dispatch: Dispatch<any>;
	t: TFunction;
	updateRefresh: VoidFunction;
}) => GridColDef[];

const useSkillsEvaluationsTableColumns: useSkillsEvaluationsTableColumnsType = ({ dispatch, t, updateRefresh }) => [
	{
		field: 'user_assigned_title',
		headerName: t('DETAILS_SKILLS_EVALUATIONS_FIELD_USER_ASSIGNED'),
		minWidth: 200,
		flex: 1,
		renderCell: ({ value, row }) =>
			ViewTableUtils.renderCellWithTooltip({ value, to: { module: 'users', uid: row.user_assigned_uid } }),
		hideable: false
	},
	{
		field: 'skev_level',
		headerName: t('DETAILS_SKILLS_EVALUATIONS_FIELD_LEVEL'),
		minWidth: 150,
		renderCell: ({ value }) => ViewTableUtils.renderSquareChip({ value }),
		hideable: false
	},
	{
		field: 'skev_d_from',
		headerName: t('DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_FROM'),
		minWidth: 150,
		renderCell: ViewTableUtils.renderDate
	},
	{
		field: 'skev_d_to',
		headerName: t('DETAILS_SKILLS_EVALUATIONS_FIELD_DATE_TO'),
		minWidth: 150,
		renderCell: ViewTableUtils.renderDate
	},
	{
		type: 'actions',
		field: 'actions',
		width: 80,
		renderCell: ({ row }) => [
			<GridActionsCellItem
				label="VIEW_ITEM_BUTTON_EDIT"
				icon={<Icon icon="edit" />}
				onClick={() => dispatch(showSkillsEvaluationsEditDialog({ model: row, updateRefresh }))}
			/>,
			<GridActionsCellItem
				label="VIEW_ITEM_BUTTON_DELETE"
				icon={<Icon icon="delete" />}
				onClick={() =>
					dispatch(
						showDeleteDialog({
							module: 'skills_evaluations',
							id: row.skev_uid,
							hardDelete: true,
							replace: false,
							updateRefresh: updateRefresh
						})
					)
				}
			/>
		],
		sortable: false
	}
];

export default useSkillsEvaluationsTableColumns;
